import { device } from 'app/ui-components/breakpoints';
import styled from 'styled-components';
import { PlayTextStyles } from '../../../../ui-components/typography/PlayText/PlayText.styles';

export const StyledTopAreaVariants = styled.p`
    ${PlayTextStyles}
    margin-bottom: 20px;

    @media ${device.GteSmall} {
        margin-bottom: 0;
    }

    .no-sweden & {
        display: none;
    }
`;
